import { render, staticRenderFns } from "./FootbowlText.vue?vue&type=template&id=bfa147be&scoped=true&"
import script from "./FootbowlText.vue?vue&type=script&lang=ts&"
export * from "./FootbowlText.vue?vue&type=script&lang=ts&"
import style0 from "./FootbowlText.vue?vue&type=style&index=0&id=bfa147be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa147be",
  null
  
)

component.options.__file = "FootbowlText.vue"
export default component.exports